export default __webpack_public_path__ + "static/media/certificate-krudew-21day.2a9d9495.pdf";